import { instance } from '../../config/intercepter';

export const getLoyaltyEligibilityFn = async () => {
  const response = await instance.get('api/loyalty/eligibility');
  return response.data;
};

export const getLoyaltyInfoFn = async () => {
  const response = await instance.get('api/loyalty/info');
  return response.data;
};

export const getLoyaltyProductsFn = async () => {
  const response = await instance.get('api/loyalty/products');
  return response.data;
};

export const registerLoyaltyFn = async (payload) => {
  const response = await instance.post('api/loyalty/register', payload);
  return response.data;
};

export const getCmsLoyaltySliderContentFn = async ({role, params}) => {
  // const response = await externalDrupalInstance.get(`el/api/mobile/${role}/Avis-More`, {
  //   params,
  // });
  const response = await instance.get(`/mobile/${role}`, {
    baseURL: process.env.REACT_APP_MIDDLEWARE_BASE_URL,
  });
  // Local proxy
  // const response = await externalDrupalLocalInstance.get(`el/api/mobile/${role}/Avis-More`, {
  //   params,
  // });
  return response.data?.data["Avis-More"];
};